import React, { ReactElement } from 'react';

import { PackagesState } from 'leash/reducers/packages/PackagesReducer';
import { ArchivedSearchDisplayResultsLabelStyled } from './ArchivedSearchDisplayResultsLabel.styles';

interface Props {
  packagesState: PackagesState;
}

function ArchivedSearchDisplayResultsLabel(props: Props): ReactElement {
  const { packagesState } = props;
  const { loading, packages } = packagesState;
  const totalPackages = packages.length;
  const label = totalPackages === 1 ? 'Result' : 'Results';

  return (
    <ArchivedSearchDisplayResultsLabelStyled className={loading ? 'loading' : ''}>
      Displaying {totalPackages} <b>{label}</b>
    </ArchivedSearchDisplayResultsLabelStyled>
  );
}

export default ArchivedSearchDisplayResultsLabel;
